// axios拦截器
import axios from 'axios'
import { Loading } from 'element-ui'
import { config } from '../config'

// loading提示窗
let loading = null

console.log('api_base_url：', config.api_base_url)
console.log('process.env.NODE_ENV：', process.env.NODE_ENV)

// 创建 axios 实例
const service = axios.create({
  // 请求地址前缀
  baseURL: process.env.NODE_ENV === 'production' ? config.api_base_url : '/test',
  // 超时时间
  timeout: 2000000
  // 跨域请求时是否需要使用凭证
  // withCredentials: true,
})

/**
 * 打开Loading层
 */
function startLoading() {
  loading = Loading.service({
    lock: true,
    text: '拼命加载中...',
    background: 'rgba(255,255,255,0)'
  })
}
/**
 * 关闭Loading层
 */
function endLoading() {
  loading.close()
}

// 请求拦截器
service.interceptors.request.use(
  configs => {
    startLoading()

    // 增加接口请求时间戳
    configs.params = {
      _t: Date.parse(new Date()) / 1000,
      ...configs.params
    }

    return configs
  },
  error => {
    // 发送请求错误操作
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    endLoading()

    return response
  },
  error => {
    const { status } = error.response // 获取状态码
    if (status === 401) {
      // 登录过期，则跳转到登录页
      window.location.replace('/login')
    }

    // 发送请求错误操作
    return Promise.reject(error)
  }
)

export default service
